const tiles = (
  state = {
    selectedLocation: {
      isFetching: true,
      locationName: '',
    },
    selectedCategory: '',
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_SELECTED_LOCATION':
      return {
        ...state,
        selectedLocation: {
          ...state.selectedLocation,
          isFetching: true,
        },
      }
    case 'RECEIVE_SELECTED_LOCATION':
      return {
        ...state,
        selectedLocation: {
          ...state.selectedLocation,
          isFetching: false,
          locationName: action.locationName,
        },
      }
    case 'RECEIVE_SELECTED_CATEGORY':
      return {
        ...state,
        selectedCategory: action.categoryName,
      }
    default:
      return state
  }
}

export default tiles
